import { HttpErrorResponse } from '@angular/common/http';

/**
 * The most useful field error from an ASP.NET validation ProblemDetails
 * ({ errors: { Field: [msg] } }), which carries no `message` - showing it beats "Failed to …"
 * with no clue why.
 *
 * When the body JSON can't be bound, ASP.NET reports the real cause under a JSON path
 * ("$.countryId": "The JSON value could not be converted…") and adds an entry for the action
 * parameter itself ("model": "The model field is required.") that names nothing useful, so a
 * JSON-path entry wins over the rest.
 */
export function firstValidationError(error: HttpErrorResponse): string | null {
  const errors = error?.error?.errors;
  if (!errors || typeof errors !== 'object') return null;
  const entries = Object.entries(errors)
    .filter(([, messages]) => Array.isArray(messages) && messages.length) as [string, unknown[]][];
  const chosen = entries.find(([key]) => key.startsWith('$')) ?? entries[0];
  return chosen ? String(chosen[1][0]) : null;
}
